"use client";

import { Detail } from "./characterViews";

function ratio(current: number, max: number): string {
  if (max <= 0) return "0%";
  return `${Math.max(0, Math.min(100, Math.round((current / max) * 100)))}%`;
}

/** HP のゲージの色。半分を越えれば緑、半分以下で黄、4 分の 1 以下で赤 */
export function hpColor(current: number, max: number): string {
  const rate = max > 0 ? current / max : 0;
  if (rate <= 0.25) return "#e06a6a";
  if (rate <= 0.5) return "#e3c04a";
  return "#5fbf6a";
}

/**
 * ステータスのタブの一番上に置く今の様子。HP とリソースの今の値・付いている状態・現在地
 */
export default function PlayNow({ detail }: { detail: Detail }) {
  const head = detail.head ?? [];
  const place = head.find((one) => one.label === "現在地")?.value.replace(/（\d+）$/, "") ?? null;
  const mods = detail.modifiers ?? [];
  const status = detail.status;
  return (
    <section className="pl-prof-sec pl-now">
      {status ? (
        <div className="pl-now-gauges">
          {[{ label: "HP", current: status.hp.current, max: status.hp.max, mp: false, color: hpColor(status.hp.current, status.hp.max) as string | null | undefined }, ...status.pools.map((pool) => ({ ...pool, mp: true }))].map((one) => (
            <div key={one.label}>
              <p className="pl-now-gauge-head">
                <span>{one.label}</span>
                <b>
                  {one.current} / {one.max}
                </b>
              </p>
              <div className={one.mp ? "pl-gauge pl-gauge-mp" : "pl-gauge"}>
                <i style={{ width: ratio(one.current, one.max), ...(one.color ? { background: one.color } : {}) }} />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      <dl className="pl-prof-pairs">
        <div>
          <dt>状態</dt>
          <dd>
            {mods.length === 0
              ? "なし"
              : mods.map((m) => (
                  <span key={m.slug} className="pl-now-mod">
                    <b className={m.kind === "強化" ? "pl-now-buff" : "pl-now-debuff"}>
                      {m.name}
                      {m.stacks > 1 ? ` ×${m.stacks}` : ""}
                    </b>
                    <small>
                      {m.remaining}
                      {m.worsen ? `・${m.worsen}` : ""}
                    </small>
                  </span>
                ))}
          </dd>
        </div>
        {place ? (
          <div>
            <dt>現在地</dt>
            <dd>{place}</dd>
          </div>
        ) : null}
      </dl>
    </section>
  );
}
